import { cn } from '@/lib/utils';
import { MethodologyCallout } from '@/shared/components/methodology-callout';
import { ROISlideOutContent } from './LearnMoreSlideOutContent';

interface ROIGuidanceProps {
  className?: string;
  disableAbsolutePosition?: boolean;
  policyType?: FundingPolicyType;
}

export function ROIGuidance({
  className = '',
  disableAbsolutePosition = false,
  policyType,
}: ROIGuidanceProps) {
  return (
    <div className={cn(disableAbsolutePosition ? '' : 'flex justify-end', className)}>
      <MethodologyCallout
        content={<ROISlideOutContent policyType={policyType} />}
        title="AI"
        variant="icon"
        maxWidth="custom-roi"
      />
    </div>
  );
}
